export function range(start, stop, step = 1){
    if(!stop){
        stop = start
        start = 0
    }
    return Array.from(new Array(Math.trunc((stop - start + step) / step)), (x, i) => start + i * step)
}
